import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The old short URL. It has always been a redirect to the canonical path, and
 * still is — links and bookmarks to /api-keys predate the move.
 *
 * The legacy version wrapped its <Navigate> in ProtectedRoute + ApiKeyRoute. This
 * one does not need to: it redirects unconditionally and the destination carries
 * the same guard, so an unpermitted user lands on the same "/" either way. Doing
 * the permission check here as well would duplicate the rule in two places, which
 * is how the two drift apart.
 */
export const Route = createFileRoute("/api-keys")({
  beforeLoad: () => {
    throw redirect({ to: "/platform/security/api-keys", replace: true });
  },
});
